import { Component,Inject,Input,Output,OnInit, EventEmitter } from '@angular/core';
import { DOCUMENT } from '@angular/common'
import { CategoriaModel } from 'src/app/core/model/categoria.model';

@Component({
  selector: 'menu-categorias',
  templateUrl: './menu-categorias.component.html',
  styleUrls: ['./menu-categorias.component.css'],
})
export class MenuCategoriasComponent implements OnInit {

  @Input()
  categorias!: CategoriaModel[];
  @Output() onSelected = new EventEmitter<any>();

  constructor(@Inject(DOCUMENT) private document : Document) { }
  ngOnInit(): void {
 
  }

  ClickCard(_url : any, _nombre : any ){
    window.open(_url, "_blank");
  }

  onSelectedCategoriaSistema(codigoCategoria: any,codigoSistema:any) {
    
    let _categoria  = this.categorias.find(x=>x.codigoCategoria === codigoCategoria);
    let _sistema   = this.categorias.find(x=>x.codigoCategoria === codigoCategoria)?.listaSistema.find(n=>n.codigoSistema===codigoSistema);
    this.onSelected.emit({ categoria :  _categoria, sistema : _sistema });
  }

}
